import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Modal, ModalContent, ModalFooter } from 'Components/Modal';
import { ICON_LIST } from 'Components/Base/Icon/SvgIcon';
import { Text } from 'Components/Base';

export const MESSAGE_TYPE = {
  COURSE_REMAINING_TIMEOUT: 'COURSE_REMAINING_TIMEOUT',
  COURSE_EXPIRE: 'COURSE_EXPIRE',
  CONCURRENT_USER: 'CONCURRENT_USER',
  ENTER_CLASSROOM_ERROR: 'ENTER_CLASSROOM_ERROR',
  UNAUTHORIZATION_ERROR: 'UNAUTHORIZATION_ERROR',
  CONTENT_UNAVAILABLE: 'CONTENT_UNAVAILABLE',
  NO_ACCESSIBLE_COURSE_LEARNED: 'NO_ACCESSIBLE_COURSE_LEARNED',
};

const getMessage = (messageType) => {
  switch (messageType) {
    case MESSAGE_TYPE.CONCURRENT_USER: {
      return {
        icon: ICON_LIST.PAAS_OTHER_DEVICE,
        title: 'ขออภัย!',
        description: 'บัญชีผู้ใช้งานนี้กำลังถูกเข้าใช้งานจากเครื่องอื่น',
      };
    }
    case MESSAGE_TYPE.COURSE_REMAINING_TIMEOUT: {
      return {
        icon: ICON_LIST.LOCKED_OUTLINE,
        title: 'ชั่วโมงเรียนหมดอายุแล้ว',
        description: `ไม่สามารถเข้าเรียนได้เนื่องจาก
        ชั่วโมงเรียนหมดอายุแล้ว`,
      };
    }
    case MESSAGE_TYPE.ENTER_CLASSROOM_ERROR: {
      return {
        icon: ICON_LIST.WARNING,
        title: 'มีข้อผิดพลาด',
        description: `กรุณาลองเข้าเรียนใหม่อีกครั้ง`,
      };
    }
    case MESSAGE_TYPE.UNAUTHORIZATION_ERROR: {
      return {
        icon: ICON_LIST.LOCKED_OUTLINE,
        title: 'ขออภัย!',
        description: `บัญชีผู้ใช้งานนี้ Session หมดอายุแล้ว`,
      };
    }
    case MESSAGE_TYPE.CONTENT_UNAVAILABLE: {
      return {
        icon: ICON_LIST.LOCKED_OUTLINE,
        title: 'ยังไม่สามารถเริ่มเรียนได้',
        description: `บทเรียนนี้ยังไม่เปิดให้บริการในเวลานี้`,
        acceptLabel: 'ปิด',
      };
    }
    // no course message for Learned user in Anywhere App
    case MESSAGE_TYPE.NO_ACCESSIBLE_COURSE_LEARNED: {
      return {
        icon: ICON_LIST.WARNING,
        title: 'พบข้อผิดพลาด',
        description: (
          <Fragment>
            <Text>ระบบไม่พบคอร์สดังกล่าวในหลักสูตร</Text>
            <Text>กรุณาติดต่อ ครูผู้สอนหรือพี่ Learn Education</Text>
          </Fragment>
        ),
      };
    }
    case MESSAGE_TYPE.COURSE_EXPIRE:
    default: {
      return {
        icon: ICON_LIST.LOCKED_OUTLINE,
        title: 'คอร์สเรียนหมดอายุแล้ว',
        description: `ไม่สามารถเข้าเรียนได้เนื่องจาก
        คอร์สเรียนนี้หมดอายุแล้ว`,
      };
    }
  }
};

const AccessContentModal = ({
  messageType,
  onClick,
  countDownTimer,
  description: descriptionProps,
  ...props
}) => {
  const { icon, title, description, acceptLabel } = getMessage(messageType);

  return (
    <Modal
      contents={
        <ModalContent
          iconName={icon}
          title={title}
          description={descriptionProps ?? description}
          countDownTimer={countDownTimer}
        />
      }
      footerProps={{ mt: 7 }}
      footer={
        <ModalFooter
          width={1}
          justifyContent={'center'}
          primaryButtonLabel={acceptLabel ?? 'กลับสู่หน้าหลัก'}
          onPrimaryButtonClick={onClick}
        />
      }
      {...props}
    />
  );
};

AccessContentModal.propTypes = {
  messageType: PropTypes.string,
  countDownTimer: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
};

AccessContentModal.defaultProps = {
  messageType: MESSAGE_TYPE.COURSE_EXPIRE,
};

export default AccessContentModal;
